import React, { useState, useEffect } from 'react';
import axios from 'axios';

const KisiselBilgilerPage = () => {
  const [profil, setProfil] = useState({});
  const [kullanici, setKullanici] = useState({});
  const [duzenle, setDuzenle] = useState(false);
  const [sifrePaneli, setSifrePaneli] = useState(false);
  const [form, setForm] = useState({});
  const [sifreForm, setSifreForm] = useState({ mevcut_sifre: '', yeni_sifre: '', tekrar: '' });
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = () => {
    axios.get('/api/personel/profil').then(r => {
      setKullanici(r.data.kullanici);
      setProfil(r.data.profil || {});
      setForm(r.data.profil || {});
    }).catch(console.error);
  };
  useEffect(() => { yukle(); }, []);

  const handleKaydet = async (e) => {
    e.preventDefault(); setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/personel/profil', form);
      setSonuc({ tip: 'basari', mesaj: 'Bilgileriniz guncellendi.' });
      setDuzenle(false); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const handleSifre = async (e) => {
    e.preventDefault();
    if (sifreForm.yeni_sifre !== sifreForm.tekrar) { setSonuc({ tip: 'hata', mesaj: 'Yeni sifreler eslesmıyor.' }); return; }
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/personel/sifre', { mevcut_sifre: sifreForm.mevcut_sifre, yeni_sifre: sifreForm.yeni_sifre });
      setSonuc({ tip: 'basari', mesaj: 'Sifreniz guncellendi.' });
      setSifrePaneli(false);
      setSifreForm({ mevcut_sifre: '', yeni_sifre: '', tekrar: '' });
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata olustu.' }); }
    finally { setYukleniyor(false); }
  };

  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '—';
  const f = (alan, val) => setForm({ ...form, [alan]: val });

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Profilim</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Kisisel bilgilerinizi goruntuleyın ve guncelleyin.</p>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1.5rem' }}>{sonuc.mesaj}</div>}

      {/* Profil banner */}
      <div className="card" style={{ marginBottom: '1.5rem', background: 'linear-gradient(135deg, var(--mavi) 0%, var(--mavi-koyu) 100%)', border: 'none', color: 'white' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div className="avatar" data-harf={kullanici.ad?.[0]} style={{ width: '64px', height: '64px', fontSize: '22px', background: 'rgba(255,255,255,0.2)', color: 'white', flexShrink: 0 }}>
            {kullanici.ad?.[0]}{kullanici.soyad?.[0]}
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px', color: 'white' }}>{kullanici.ad} {kullanici.soyad}</h3>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)', marginBottom: '8px' }}>{profil.pozisyon || '—'} {profil.departman ? '· ' + profil.departman : ''}</p>
            <div style={{ display: 'flex', gap: '16px', fontSize: '12px', color: 'rgba(255,255,255,0.7)', flexWrap: 'wrap' }}>
              <span>✉️ {kullanici.email}</span>
              {profil.telefon && <span>📞 {profil.telefon}</span>}
              {profil.ise_giris_tarihi && <span>📅 {fmt(profil.ise_giris_tarihi)} tarihinden beri</span>}
            </div>
          </div>
          {!duzenle && (
            <button className="btn btn-secondary" onClick={() => setDuzenle(true)}
              style={{ background: 'rgba(255,255,255,0.15)', color: 'white', border: '1px solid rgba(255,255,255,0.3)', flexShrink: 0 }}>
              Duzenle
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>

        {/* Sol - Kisisel Bilgiler */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>👤</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>Kisisel Bilgiler</div>
                <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Iletisim ve temel bilgiler</div>
              </div>
            </div>

            {!duzenle ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[
                  { label: 'Telefon', value: profil.telefon, ikon: '📞' },
                  { label: 'Dogum Tarihi', value: fmt(profil.dogum_tarihi), ikon: '🎂' },
                  { label: 'Adres', value: profil.adres, ikon: '📍' },
                  { label: 'Acil Iletisim', value: profil.acil_iletisim_ad, ikon: '🆘' },
                  { label: 'Acil Telefon', value: profil.acil_iletisim_tel, ikon: '📱' },
                ].map(b => (
                  <div key={b.label} style={{ display: 'flex', gap: '10px', padding: '8px 10px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)' }}>
                    <span style={{ fontSize: '16px', flexShrink: 0 }}>{b.ikon}</span>
                    <div>
                      <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{b.label}</div>
                      <div style={{ fontSize: '13px', fontWeight: '500' }}>{b.value || '—'}</div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <form onSubmit={handleKaydet}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <div className="form-group"><label>Telefon</label><input type="tel" value={form.telefon || ''} onChange={e => f('telefon', e.target.value)} /></div>
                  <div className="form-group"><label>Dogum Tarihi</label><input type="date" value={form.dogum_tarihi || ''} onChange={e => f('dogum_tarihi', e.target.value)} /></div>
                  <div className="form-group"><label>Adres</label><textarea value={form.adres || ''} onChange={e => f('adres', e.target.value)} rows={2} /></div>
                  <div className="form-group"><label>Acil Iletisim Kisisi</label><input type="text" value={form.acil_iletisim_ad || ''} onChange={e => f('acil_iletisim_ad', e.target.value)} /></div>
                  <div className="form-group"><label>Acil Telefon</label><input type="tel" value={form.acil_iletisim_tel || ''} onChange={e => f('acil_iletisim_tel', e.target.value)} /></div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '1rem' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => { setDuzenle(false); setForm(profil); }}>Iptal</button>
                </div>
              </form>
            )}
          </div>

          {/* Is Bilgileri */}
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--yesil-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>💼</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>Is Bilgileri</div>
                <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Departman ve pozisyon</div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { label: 'Departman', value: profil.departman, ikon: '🏢' },
                { label: 'Pozisyon', value: profil.pozisyon, ikon: '🎯' },
                { label: 'Ise Giris', value: fmt(profil.ise_giris_tarihi), ikon: '📅' },
              ].map(b => (
                <div key={b.label} style={{ display: 'flex', gap: '10px', padding: '8px 10px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)' }}>
                  <span style={{ fontSize: '16px', flexShrink: 0 }}>{b.ikon}</span>
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{b.label}</div>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{b.value || '—'}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Sag - Sifre ve Guvenlik */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--sari-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>🔐</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>Guvenlik</div>
                <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Sifre ve hesap guvenligi</div>
              </div>
            </div>

            {!sifrePaneli ? (
              <div>
                <div style={{ padding: '1rem', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', marginBottom: '1rem' }}>
                  <div style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', lineHeight: '1.6' }}>
                    🛡️ Guvenliginiz icin sifrenizi duzenli olarak guncelleyin. Sifreniz en az 6 karakter olmalidir.
                  </div>
                </div>
                <button type="button" className="btn btn-primary" onClick={() => setSifrePaneli(true)} style={{ width: '100%' }}>
                  🔑 Sifre Degistir
                </button>
              </div>
            ) : (
              <form onSubmit={handleSifre}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1rem' }}>
                  <div className="form-group">
                    <label>Mevcut Sifre *</label>
                    <input type="password" value={sifreForm.mevcut_sifre} onChange={e => setSifreForm({ ...sifreForm, mevcut_sifre: e.target.value })} required autoComplete="current-password" />
                  </div>
                  <div className="form-group">
                    <label>Yeni Sifre *</label>
                    <input type="password" value={sifreForm.yeni_sifre} onChange={e => setSifreForm({ ...sifreForm, yeni_sifre: e.target.value })} required minLength={6} autoComplete="new-password" />
                  </div>
                  <div className="form-group">
                    <label>Yeni Sifre (Tekrar) *</label>
                    <input type="password" value={sifreForm.tekrar} onChange={e => setSifreForm({ ...sifreForm, tekrar: e.target.value })} required autoComplete="new-password" />
                    {sifreForm.tekrar && sifreForm.yeni_sifre !== sifreForm.tekrar && (
                      <div style={{ fontSize: '12px', color: 'var(--kirmizi)', marginTop: '4px' }}>Sifreler eslesmıyor</div>
                    )}
                    {sifreForm.tekrar && sifreForm.yeni_sifre === sifreForm.tekrar && sifreForm.tekrar.length >= 6 && (
                      <div style={{ fontSize: '12px', color: 'var(--yesil)', marginTop: '4px' }}>✓ Sifreler eslesiyor</div>
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ flex: 1 }}>{yukleniyor ? 'Kaydediliyor...' : 'Guncelle'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => { setSifrePaneli(false); setSifreForm({ mevcut_sifre: '', yeni_sifre: '', tekrar: '' }); }}>Iptal</button>
                </div>
              </form>
            )}
          </div>

          {/* Hesap Bilgileri */}
          <div className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--mavi-acik)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>ℹ️</div>
              <div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>Hesap Bilgileri</div>
                <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>Sistem tarafindan yonetilir</div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { label: 'E-posta', value: kullanici.email, ikon: '✉️' },
                { label: 'Rol', value: kullanici.rol, ikon: '🔑' },
              ].map(b => (
                <div key={b.label} style={{ display: 'flex', gap: '10px', padding: '8px 10px', background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)' }}>
                  <span style={{ fontSize: '16px', flexShrink: 0 }}>{b.ikon}</span>
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{b.label}</div>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{b.value || '—'}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default KisiselBilgilerPage;
